
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrmModuleData } from '../interface/crm';
import { CrmModuleApi } from '../api/crm.api';


@Injectable()
export class CrmModuleService extends CrmModuleData {

  constructor(private api:  CrmModuleApi) {
    super();
  }

  list(url: string): Observable< any[]> {
    return this.api.list(url);
  }
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

  getById(url:string): Observable< any>{
      return this.api.getById(url);
  }

  create(url: string, data: any): Observable< any> {
    return this.api.create(url,data);
  }

  update(url: string, data: any): Observable< any> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

}
